'use client';

import React from 'react';

import { VelocitySetInputPropTypes } from './VelocitySetInput.types';

// Shared column template so the set rows stay aligned with the column headings above them.
export const VELOCITY_SET_GRID =
  'grid grid-cols-[4.4rem_1fr_1fr] items-center gap-[1rem] sm:grid-cols-[6rem_1fr_1fr] sm:gap-[1.6rem]';

const inputClassName =
  '[&::-webkit-inner-spin-button]:m-0 [&::-webkit-outer-spin-button]:m-0 w-full bg-transparent text-right text-[1.4rem] font-normal outline-hidden sm:text-[1.8rem] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none';

const VelocitySetInput: React.FC<VelocitySetInputPropTypes> = ({
  className = '',
  index,
  loadLabel,
  load,
  velocity,
  onLoadChange,
  onVelocityChange,
}) => {
  return (
    <div
      className={`${VELOCITY_SET_GRID} rounded-lg bg-[#F8F8F8] px-[1rem] py-[1rem] text-[1.2rem] sm:px-[2rem] ${className}`}
    >
      <span className='text-[1rem] font-medium sm:text-[1.2rem]'>Set {index}</span>

      <div className='flex items-center border-l-[0.2rem] border-[#D9D9D9] pl-[1rem] sm:pl-[1.6rem]'>
        <input
          type='number'
          min='0'
          step='any'
          inputMode='decimal'
          aria-label={`Set ${index} load in ${loadLabel}`}
          value={load}
          onChange={onLoadChange}
          className={inputClassName}
          placeholder='0.0'
        />
      </div>

      <div className='flex items-center border-l-[0.2rem] border-[#D9D9D9] pl-[1rem] sm:pl-[1.6rem]'>
        <input
          type='number'
          min='0'
          step='any'
          inputMode='decimal'
          aria-label={`Set ${index} mean velocity in metres per second`}
          value={velocity}
          onChange={onVelocityChange}
          className={inputClassName}
          placeholder='0.00'
        />
      </div>
    </div>
  );
};

export default VelocitySetInput;
